const { I18n, getCurrentUser, getExternalUser, APP_CONSTANTS, AppState, $, ENV_VARS, env, getUrlParameters } = window;

export { I18n, getCurrentUser, getExternalUser, APP_CONSTANTS, AppState, $, ENV_VARS, env, getUrlParameters };
